import { createContext } from 'react';

export const CancellationSettings = createContext({
  reasonCodes: [],
  reasonCodesSettingPageUrl: '',
  reasonCode: '',
  setReasonCode: () => {},
});